import {DocumentStorage} from '../office-js/DocumentStorage';
import {HostAppName} from '../office-js/HostAppSettings';
import {DocumentStorageOneNote} from '../OneNote/DocumentStorageOneNote';
import {DocumentStorageWord} from '../Word/DocumentStorageWord';
import {HostAppUtil} from '../office-js/HostAppUtil';

export function CreateDocumentStorage(): DocumentStorage {
  switch (HostAppUtil.GetHostAppName()) {
    case HostAppName.ONENOTE:
      return new DocumentStorageOneNote();
    case HostAppName.WORD:
      return new DocumentStorageWord();
    default:
      throw new Error('Requested App Name not supported by DocumentStorageFactory.');
  }
}
